<template lang="pug" src="./admins.pug"></template>
<style lang="scss" src="./admins.scss" scoped></style>

<script>
import scroll from '@/utils/scroll'

import { mapState, mapGetters } from 'vuex'

export default {
    data: () => ({
        filters: {
            fromDate: null,
            toDate: null,
            email: null,
            name: null
        },
        sorting: {}
    }),
    computed: {
        ...mapGetters(['type', 'permissions']),
        ...mapState({
            admins: state => state.admin.admins,
            isTableLoad: state => state.admin.isLoaded,
            pagination: state => state.admin.pagination,
            appliedFilters: state => state.admin.filters
        }),
        headers: function() {
            return [
                { text: 'id', value: '"id"' },
                { text: 'email', value: '"email"' },
                { text: 'firstName', value: '"firstName"' },
                { text: 'lastName', value: '"lastName"' },
                { text: 'cardNumber', value: '"cardNumber"' },
                { text: 'taxId', value: '"taxId"' },
                { text: 'phoneNumber', value: '"phoneNumber"' },
                { text: 'role', value: '"role"."name"' },
                { text: 'createdAt', value: '"createdAt"' },
                { text: 'actions', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.t(`$vuetify.pages.Admins.table.${it.text}`)
            }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getAdminsByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getAdminsByPage()
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('admin/SET_PAGINATION', { page: 1, length: null })
        next()
    },
    methods: {
        submit() {
            this.$store.commit('admin/SET_FILTERS', Object.assign({}, this.filters))
            this.getAdminsByPage()
        },
        reset() {
            this.filters = Object.assign({}, {
                fromDate: null,
                toDate: null
            })
            this.$store.commit('admin/RESET_ADMIN_FILTERS')
            this.getAdminsByPage()
        },
        getAdminsByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('admin/getAdmins', {
                excel,
                page,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getAdminsByPage(page, true)
            }
        },
        addAccount() {
            this.$store.commit('createAccount/SET_ACTIVE_TYPE', 'admin')
            this.$router.push('/create-account')
        },
        openEditor(id) {
            this.$router.push(`admins/editor/${id}`)
        },
        exportToExcel() {
            this.getAdminsByPage(1, false, true)
        }
    }
}
</script>
